import { render } from "./TerminationModal.vue?vue&type=template&id=dbb1a714&scoped=true"
import script from "./TerminationModal.vue?vue&type=script&lang=js"
export * from "./TerminationModal.vue?vue&type=script&lang=js"

import "./TerminationModal.vue?vue&type=style&index=0&id=dbb1a714&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb1a714"]])

export default __exports__